import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@/shared/components/Button/Button';
import { useClientSupport } from '@/shared/hooks/useClientSupport';

import styles from './styles.module.css';

interface INeedHelpProps {
    isLink?: boolean;
}

export const SupportButton: React.FC<INeedHelpProps> = ({ isLink = false }) => {
    const { openClientSupport } = useClientSupport();
    const intl = useIntl();

    return (
        <span className={styles.container}>
            <Button
                onClick={openClientSupport}
                size={52}
                variant={isLink ? 'secondaryTransparent' : 'secondary'}
                theme="dark"
            >
                {intl.formatMessage({
                    id: 'features.support-chat.ad119d5ea30f6c26b58e0af5bc43c9fe',
                    defaultMessage: 'Contact support',
                    description: 'Текст ссылки на страницу поддержки',
                })}
            </Button>
        </span>
    );
};
